import { RouteRecordRaw } from 'vue-router'

export const tertiaryCareMapRoutes: RouteRecordRaw[] = [
  {
    path: '/mapa-de-internacoes-hospitalar/cirurgias/:id',
    name: 'TertiaryCareAttendanceSurgeryView',
    component: () =>
      import(
        /* webpackChunkName: "TertiaryCareAttendanceView" */
        '../views/TertiaryCareAttendanceView.vue'
      ),
    meta: {
      title: 'Cirurgia Eletiva',
      onlyLoggedIn: true,
      attendanceType: 'SURGERY'
    }
  },
  {
    path: '/mapa-de-internacoes-hospitalar/internacoes/:id',
    name: 'TertiaryCareAttendanceHospitalizationView',
    component: () =>
      import(
        /* webpackChunkName: "TertiaryCareAttendanceView" */
        '../views/TertiaryCareAttendanceView.vue'
      ),
    meta: {
      title: 'Internação Hospitalar',
      onlyLoggedIn: true,
      attendanceType: 'HOSPITALIZATION'
    }
  },
  {
    path: '/mapa-de-internacoes-hospitalar',
    name: 'TertiaryCareMapView',
    component: () =>
      import(
        /* webpackChunkName: "TertiaryCareMapView" */
        '../views/TertiaryCareMapView.vue'
      ),
    meta: {
      title: 'Mapa de internações',
      onlyLoggedIn: true
    }
  }
]
